import "firebase/compat/firestore";
import "firebase/compat/auth";
import "firebase/compat/storage";
import { firestore as db } from "src/Firebase";

export const getImagen = (Banco) => db.collection("banco").doc(Banco);

export const newAccountBank = (Conjunto, AccountBank, Imagen) =>
  db.collection("conjuntos").doc(Conjunto).collection("cuentas").add({
    NombreCuenta: AccountBank.NombreCuenta,
    NumeroCuenta: AccountBank.NumeroCuenta,
    TipoIdentificacion: AccountBank.TipoIdentificacion,
    TipoCuenta: AccountBank.TipoCuenta,
    Identificacion: AccountBank.Identificacion,
    Correo: AccountBank.Correo,
    Banco: AccountBank.Banco,
    SaldoInicial: AccountBank.SaldoInicial,
    FechaCorte: AccountBank.FechaCorte,
    Logo: Imagen,
    TipoMetodo: "Cuenta Bancaria",
  });

export const getCuentabyConjunto = (observer, Conjunto) =>
  db
    .collection("conjuntos")
    .doc(Conjunto)
    .collection("cuentas")
    .where("TipoMetodo", "==", "Cuenta Bancaria")
    .onSnapshot(observer);

export const getCajasbyConjunto = (observer, Conjunto) =>
  db
    .collection("conjuntos")
    .doc(Conjunto)
    .collection("cuentas")
    .where("TipoMetodo", "==", "Caja")
    .onSnapshot(observer);

export const getAllBanks = (observer) =>
  db.collection("banco").onSnapshot(observer);

export const updateCuenta = (Conjunto, AccountBank, documentoId) =>
  db
    .collection("conjuntos")
    .doc(Conjunto)
    .collection("cuentas")
    .doc(documentoId)
    .update({
      NombreCuenta: AccountBank.NombreCuenta,
      NumeroCuenta: AccountBank.NumeroCuenta,
      TipoIdentificacion: AccountBank.TipoIdentificacion,
      TipoCuenta: AccountBank.TipoCuenta,
      Identificacion: AccountBank.Identificacion,
      Correo: AccountBank.Correo,
      Banco: AccountBank.Banco,
    });

export const deleteCuentabyID = (Conjunto, cuentaId) =>
  db
    .collection("conjuntos")
    .doc(Conjunto)
    .collection("cuentas")
    .doc(cuentaId)
    .delete();

export const updateTranferencia = (
  Conjunto,
  documentoId,
  tranferenciaId,
  cantidad
) =>
  db
    .collection("conjuntos")
    .doc(Conjunto)
    .collection("cuentas")
    .doc(documentoId)
    .collection("transferencias")
    .doc(tranferenciaId)
    .update({
      estado: "Aprobado",
      cantidadRecibida: cantidad,
    });

export const getDetallesPago = (Usuario, Detalles) =>
  db
    .collection("usuarios")
    .doc(Usuario)
    .collection("valoresPendientes")
    .doc(Detalles);

export const deleteValoresPendientes = (Usuario, ValorPendiente) =>
  db
    .collection("usuarios")
    .doc(Usuario)
    .collection("valoresPendientes")
    .doc(ValorPendiente)
    .delete();

export const newHistorial = (Usuario, Cuenta, Transferencia) =>
  db.collection("usuarios").doc(Usuario).collection("HistorialPagos").add({
    Usuario,
    Cuenta,
    Tranferencia: Transferencia,
    FechaConfirmacion: new Date(),
  });

export const getUserByConjunto = (observer, conjuntoID) =>
  db
    .collection("usuarios")
    .where("ConjuntoUid", "==", conjuntoID)
    .onSnapshot(observer);

export const getConjunto = (conjuntoID) =>
  db.collection("conjuntos").doc(conjuntoID).get();
export const newSaldo = (conjuntoID, data) =>
  db
    .collection("conjuntos")
    .doc(conjuntoID)
    .collection("ingresos")
    .doc()
    .set(data);
export const newIngreso = (conjuntoID, data) =>
  db.collection("conjuntos").doc(conjuntoID).collection("ingresos").doc().set({
    Valor: data.Valor,
    Descripcion: data.Descripcion,
    Fecha: new Date(),
    Forma: data.Forma,
    CuentaUid: data.CuentaDestino,
    Cobros: data.Valores,
    Usuario: "Transferencia de fondos",
    Comprobante: data.Comprobante,
    Conciliado: false,
    ComprobanteTransaccion: data.ComprobanteTransaccion,
  });
export const newEgreso = (conjuntoID, data) =>
  db.collection("conjuntos").doc(conjuntoID).collection("egresos").doc().set({
    Valor: data.Valor,
    Descripcion: data.Descripcion,
    Fecha: new Date(),
    CuentaUid: data.CuentaOrigen,
    Pagos: data.ValoresEgr,
    Forma: data.Forma,
    Proveedor: data.Proveedor,
    Comprobante: data.Comprobante,
    Nombre: "Transferencia de fondos",
    Conciliado: false,
    Factura: data.Factura,
    NumeroComprobanteEgreso: data.NumeroComprobanteEgreso,
    createEgreso: new Date()
  });

export const getIngresos = (observer, conjuntoUid, cuentaUid) =>
  db
    .collection("conjuntos")
    .doc(conjuntoUid)
    .collection("ingresos")
    .where("CuentaUid", "==", cuentaUid)
    .onSnapshot(observer);

export const getEgresos = (observer, conjuntoUid, cuentaUid) =>
  db
    .collection("conjuntos")
    .doc(conjuntoUid)
    .collection("egresos")
    .where("CuentaUid", "==", cuentaUid)
    .onSnapshot(observer);

export const getConjuntoComprobante = (observer, Conjunto) =>
  db.collection("conjuntos").doc(Conjunto).onSnapshot(observer);

export const updateComprobante = (conjuntoUid, data) =>
  db.collection("conjuntos").doc(conjuntoUid).update({
    NumeroComprobante: data.Ingreso,
    NumeroComprobanteEgreso: data.Egreso,
  });

export const anularSaldoI = async (idConjunto, ingreso) => {
  const data = ingreso;
  const batch = db.batch();
  const cobros = data.Cobros;
  const updateCobros = [];

  cobros.forEach((cobro) => {
    updateCobros.push({
      Casa: cobro?.Casa || "",
      Descripcion: cobro?.Descripcion || '',
      Rubro: cobro.Rubro,
      SubRubro: cobro.SubRubro,
      Valor: 0,
    });
  });
  const incomeRef = db
    .collection(`conjuntos/${idConjunto}/ingresos`)
    .doc(ingreso.id);
  batch.update(incomeRef, {
    Cobros: updateCobros,
    Descripcion: "Anulación",
    Conciliado: true,
    Valor: 0,
    Saldo: 0,
    Descuento: 0,
    esAnticipoCuentas: false,
  });

  return batch.commit();
};
